<template>
  <Modal
    ref="modal"
    bgcolor="rgba(0,0,0,0.3)"
    @closed="onClosed"
  >
    <div class="profile-modal">
      <i
        class="isif isif-close"
        @click="hide"
      />
      <div class="profile-modal-inner">
        <div class="profile-modal-portrait">
          <div class="profile-modal-portrait-inner">
            <div
              v-if="customBranding"
              class="profile-modal-portrait-user"
            >
              <img
                v-if="portrait"
                :src="portrait"
              >
              <i
                v-else
                class="isif isif-man"
              />
            </div>
            <img
              v-else
              class="profile-modal-portrait-istaging"
              :src="iStagingPortrait"
            >
          </div>
        </div>
        <div class="profile-modal-name">
          <span>{{ name }}</span>
        </div>
        <ul class="profile-modal-detail">
          <li v-if="companyDisplayName">
            <i class="isif isif-brief-case" />
            <span>{{ companyDisplayName }}</span>
          </li>
          <li v-if="phone">
            <i class="isif isif-phone" />
            <a :href="`tel:${phone}`">{{ phone }}</a>
          </li>
          <li v-if="displayEmail">
            <i class="isif isif-drawer" />
            <a
              v-if="email"
              :href="`mailto:${email}`"
              target="_blank"
              v-text="email"
            />
            <span
              v-else
              v-text="$t('None')"
            />
          </li>
        </ul>
      </div>
    </div>
  </Modal>
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'
import Modal from '../../../IModal'
import iStagingPortrait from '@/assets/images/istaging.svg'

export default {
  name: 'ModalProfile',
  components: {
    Modal
  },
  computed: {
    ...mapGetters([
      'user',
      'currentBuilding'
    ]),
    profile () {
      const {
        showAdminProfile,
        adminProfile
      } = this.user

      return showAdminProfile && adminProfile ? adminProfile : this.user
    },
    portrait () {
      // if (_.has(this.profile.portrait, 'cutUrl')) {
      //   return this.profile.portrait.cutUrl
      // }
      return this.profile.profileUrl || null
    },
    iStagingPortrait () {
      return iStagingPortrait
    },
    name () {
      return this.profile.name || this.$t('None')
    },
    companyDisplayName () {
      return this.profile.companyDisplayName
    },
    phone () {
      return this.profile.phone
    },
    email () {
      return this.profile.email
    },
    customBranding () {
      const { customSetting } = this.profile
      return customSetting.customBranding
    },
    displayEmail () {
      const { displayEmail } = this.user
      return displayEmail
    }
  },
  methods: {
    show () {
      this.$refs.modal.show()
      this.$store.dispatch('setOwnerInfoActive', true)
    },
    hide () {
      this.$refs.modal.hide()
    },
    onClosed () {
      this.$emit('close')
      this.$store.dispatch('setOwnerInfoActive', false)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';

.profile-modal {
  width: 95%;
  padding: 40px 52px 53px;
  position: relative;
  border-radius: 5px;
  background-color: $black;
  color: $white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  @media (min-width: $response) {
    width: 386px;
  }

  .profile-modal-name {
    margin: 1.5rem 0;
    font-size: 1.875em;
    text-align: center;
    word-break: break-word;
  }

  .profile-modal-portrait {
    width: 5.75rem
    margin: auto;
  }

  .profile-modal-portrait-inner {
    position: relative;
    padding-top: 100%;
  }

  .profile-modal-portrait-user,
  .profile-modal-portrait-istaging {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    overflow: hidden;
  }

  .profile-modal-portrait-user {
    i, img {
      width: 100%;
      height: 100%;
    }

    i {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $white;
      color: $dusty-gray;
      font-size: 4.3125rem;
    }
  }

  .profile-modal-portrait-istaging {
    width: 100%;
    height: 100%;
  }

  ul.profile-modal-detail {
    li {
      margin-top: 1.3em;
      display: flex;
      align-items: flex-start;
      word-break: break-word;

      i {
        margin-right: 1rem;
        font-size: 1.25em;
      }

      span {
        align-self: center;
      }

      &:first-child {
        margin-top: 0;
      }
    }
    .reserve {
      margin: 0 10px
      padding: 3px 10px
      border-radius: 5px
      border: 1px solid #FFF
      cursor: pointer

      &:hover {
        border-color: $pink-color
      }
    }
  }

  .isif-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    padding: 0.75rem;
    font-size: 1.5em;
    color: rgba(255, 255, 255, 0.54);
    cursor: pointer;
  }
}
</style>
